import { ComponentPropsWithoutRef } from "react";
import cx from "classnames";

import styles from "./TableBody.module.scss";

/**
 * Props for the TableBody component
 * @extends ComponentPropsWithoutRef<"tbody">
 * @extends ComponentPropsWithoutRef<"div">
 */
export type TableBodyProps =
  | ({
      /**
       * The type of table being rendered
       */
      type: "simple";
    } & ComponentPropsWithoutRef<"tbody">)
  | ({
      /**
       * The type of table being rendered
       */
      type: "data-table";
    } & ComponentPropsWithoutRef<"div">);

/**
 * Table body component for simple presentational or complex data tables
 * @param props - The props for the TableBody component
 * @param props.type - The type of table being rendered
 * @param props.children - The children of the TableBody component
 * @param props.ref - The ref of the TableBody component
 */
export function TableBody({ type, children, ...rest }: TableBodyProps) {
  const classes = cx(styles["table-body"], rest.className);
  const Element = type === "simple" ? "tbody" : "div";

  return (
    <Element
      {...rest}
      className={classes}
      role={type === "simple" ? undefined : "rowgroup"}
    >
      {children}
    </Element>
  );
}
